import Head from 'next/head'
import React from 'react'
import {ThemeProvider} from 'styled-components'
import {Box, GlobalStyle, HeaderLogo} from '@miro-site/core'
import {theme} from '@miro-site/design-tokens'
import '@miro-site/ui-design-system/src/styles/wcds-vis-theme.scss'

interface StyledComponentsLayoutProps {
  children: React.ReactNode
}

function StyledComponentsLayout({children}: StyledComponentsLayoutProps): React.ReactElement {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <ThemeProvider theme={defaultTheme => ({...defaultTheme, ...theme})}>
        <GlobalStyle />
        <Box as="header" $px={12}>
          <HeaderLogo href="/" />
          <Box $styles={{height: 66}} />
        </Box>
        <Box $px="12" as="main">
          {children}
        </Box>
      </ThemeProvider>
    </>
  )
}

export default StyledComponentsLayout
